import { Injectable } from '@angular/core';
import { ActiveToast, GlobalConfig, ToastrService } from 'ngx-toastr';
import { ToastrNotifictionComponent } from '../components/toastr-notifiction/toastr-notifiction.component';

interface ErrorEntry {
  count: number;
  timer?: any;
}

@Injectable({
  providedIn: 'root',
})

export class ToastrWrapperService {
  private options: any;
  private toastrType = {
    error: 'toast-error',
    info: 'toast-info',
    success: 'toast-success',
    warning: 'toast-warning',
  };
  private type: string;

  private errorAggregation = new Map<string, ErrorEntry>()
  private aggregationDelay = 1000

  constructor(private toastr: ToastrService) {
    this.options = this.toastr.toastrConfig;
    this.options.extendedTimeOut = 5000;
    this.options.closeButton = true;
    this.options.tapToDismiss = false;
    this.options.toastComponent = ToastrNotifictionComponent;
    this.options.positionClass = 'toast-bottom-right';
  }

  showSuccess(messege: string = 'تغییرات ذخیره شد.', timeOut = 8000): ActiveToast<any> {
    this.options.timeOut = timeOut;
    this.options.disableTimeOut = !timeOut;
    this.options.type = this.toastrType.success;
    return this.toastr.show(messege, 'موفق', this.options);
  }

  showInfo(messege: string, timeOut = 8000): ActiveToast<any> {
    this.options.timeOut = timeOut;
    this.options.disableTimeOut = !timeOut;
    this.options.type = this.toastrType.info;
    return this.toastr.show(messege, 'اطلاع رسانی', this.options);
  }

  showError(message: string = 'تغییرات ناموفق بود.', timeOut = 8000): ActiveToast<any> {
    if (this.shouldSkipError(message)) {
      console.warn('Skipping error notification:', message);
      return null; 
    }

    this.options.timeOut = timeOut;
    this.options.disableTimeOut = !timeOut;
    this.options.type = this.toastrType.error;
    // return this.toastr.show(message, 'خطا', this.options);

    let entry = this.errorAggregation.get(message)
    if(!entry) {
      entry = { count: 1 }
      entry.timer = setTimeout(() => {
        const finalCount = entry!.count
        const displayMessage = finalCount > 1? `${message} (${finalCount})` : message

        this.toastr.show(displayMessage, 'خطا', this.options)
        this.errorAggregation.delete(message)

      }, this.aggregationDelay)

      this.errorAggregation.set(message, entry)
      return null
    }

    entry.count++
    return
  }

  showWarning(messege: string, timeOut = 8000): ActiveToast<any> {
    this.options.timeOut = timeOut;
    this.options.disableTimeOut = !timeOut;
    this.options.type = this.toastrType.warning;
    return this.toastr.show(messege, 'اخطار', this.options);
  }

  removeToast(toastId: number): void {
    this.toastr.remove(toastId);
  }

  private shouldSkipError(message: string): boolean {
    const unwantedErrorMessages = [
      'Authentication failed. Invalid Refresh Token. invalid refresh token user id',
    ];
    return unwantedErrorMessages.some((unwantedMessage) => message.includes(unwantedMessage));
  }
}
